import React, { useEffect, useState } from "react";
import "./newGroupSelect.sass";
import { Select, Tooltip } from "antd";
import { TitleCustom } from "src/components/custom";
import { TagRender } from "./tagRender";
import { FullscreenOutlined, FullscreenExitOutlined, CheckSquareOutlined } from "@ant-design/icons";

interface NewGroupProps {
  style?: React.CSSProperties;
  title: string;
  options: any[];
  isValueFormated?: boolean
  placeholder: string;
  useToolTip?: boolean;
  setData: (val: any) => void;
  data: any
  onlyOneData?: boolean;
  currentPage?: number;
  pageSize?: number;
  disabled?: boolean;
  titleCustom?: JSX.Element;
  onSearch?: (value: any) => void;
  setCurrentPage?: React.Dispatch<React.SetStateAction<number>>;
  onChange?: () => void;
}

export const NewGroupSelect = (props: NewGroupProps) => {
  const { title, options, placeholder, setData, data, onlyOneData = false, disabled = false, titleCustom, useToolTip, onSearch, isValueFormated = true } = props;
  const [maxTag, setMaxTag] = useState(onlyOneData ? 1 : 4);
  const canExpanded = !onlyOneData ? data.length > 4 : true;
  const [changed, setChanged] = useState<boolean>(false);
  const mergedOptions = [
    ...data,
    ...options.filter((o) => !data.find((s) => s.id === o.id)),
  ];
  // Carga inicial


  const handleChange = (value) => {
    if (onlyOneData) {
      setData(value);
    } else {
      if (!isValueFormated) {

        // const selectedObjects = [
        //   ...data,
        //   ...options.filter(
        //     (opt) => value.includes(opt.id) && !data.some((s) => s.id === opt.id)
        //   ),
        // ];

        // const uniqueSelected = selectedObjects.filter((obj, index, self) =>
        //   index === self.findIndex((o) => o.id === obj.id)
        // );
        const allAvailable = [...data, ...options];

        // Filtra solo objetos con ID dentro de 'value'
        const newSelected = allAvailable.filter((item) => value.includes(item.id));

        // Elimina duplicados (por si)
        const uniqueSelected = newSelected.filter(
          (obj, index, self) => index === self.findIndex((o) => o.id === obj.id)
        );
        setData(uniqueSelected);
      } else {
        setData(value.map(v => ({ ...options.find(opt => opt?.id === v), selected: true })));

      }

    }
    setChanged(true);
  };

  const selectAllItems = (): void => {
    if (!isValueFormated) {
      setData(options.map(opt => ({ ...options.find(o => o?.id == opt.id), selected: true })));

    } else {
      setData(options.map(opt => ({ ...options.find(o => o?.id == opt.id), selected: true })));
    }

    setChanged(true);
  }

  useEffect(() => {
    if (changed && props.onChange) {
      props.onChange();
      setChanged(false);
    }
  }, [changed])


  return (
    <div id="new-group-select" style={props.style} >
      <div className="title-img d-flex justify-content-between">
        {titleCustom ? titleCustom : <TitleCustom level={3} class="title-group-select" text={title} />}
        <div>
          <CheckSquareOutlined onClick={selectAllItems} className={`align-self-center bg-opacity-50 icon`} style={{ marginRight: "5px" }} />
          {!onlyOneData ? maxTag
            ? <FullscreenOutlined
              className={`align-self-center bg-opacity-50 icon ${!canExpanded ? 'disabled' : ''}`}
              onClick={() => setMaxTag(prevVal => prevVal ? null : 4)}
            />
            : <FullscreenExitOutlined
              className={`align-self-center bg-opacity-50 icon ${!canExpanded ? 'disabled' : ''}`}
              onClick={() => setMaxTag(prevVal => prevVal ? null : 4)}
            />
            : null
          }
        </div>
      </div>
      <Select
        tagRender={TagRender}
        mode={onlyOneData ? undefined : "multiple"}
        allowClear
        showSearch
        style={{
          width: "100%"
        }}
        onSearch={onSearch}
        placeholder={placeholder}
        onChange={(e) => handleChange(e)}
        filterOption={isValueFormated ? (value: any, option) => {
          const match: boolean = (option!.children as unknown as string).toLowerCase().includes(value.toLowerCase())

          return match;
        } : false}
        value={onlyOneData ? data : data?.map((opt) => opt?.id)}
        maxTagCount={maxTag}
        disabled={disabled}
      >
        {isValueFormated ? options?.map((opt) => (
          <Select.Option key={opt?.id} value={opt?.id}>
            {useToolTip ? <span className="flex-col-start" title={opt.address}>{opt.name}<small className="ant-typography" style={{ display: "block" }}>{opt?.address}</small></span> : opt?.name}

          </Select.Option>
        )) : mergedOptions?.map((opt) => (
          <Select.Option key={opt?.id} value={opt?.id}>


            {useToolTip ? <span className="flex-col-start" title={opt.address}>{opt.name}<small className="ant-typography" style={{ display: "block" }}>{opt?.address}</small></span> : opt?.name}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};
